export function formatEventDateTime(
  isoString: string,
  timezone: string,
): { formatted: string; abbreviation: string } {
  const date = new Date(isoString);

  const formatted = new Intl.DateTimeFormat('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZone: timezone,
    timeZoneName: 'short',
  }).format(date);

  // Extract timezone abbreviation (e.g. "CDT", "EST")
  const abbreviation =
    new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      timeZoneName: 'short',
    })
      .formatToParts(date)
      .find((p) => p.type === 'timeZoneName')?.value ?? '';

  return { formatted, abbreviation };
}
